import { GridFilterItem } from "@mui/x-data-grid-pro";
import jwt_decode from "jwt-decode";

interface ACCESS_TOKEN {
  exp: number;
  iss: string;
  aud: string;
  client_id: string;
  sub: string;
  auth_time: number;
  idp: string;
  role: string;
  name: string;
  given_name: string;
  profile: string;
  jti: string;
  iat: number;
  scope: string[];
  amr: string[];
}

// Decode Token:
export const decodeToken = (token: any) => {
  const decodedJwt: ACCESS_TOKEN = jwt_decode(token);
  return decodedJwt;
};

// Get DealerId From Token
export const getDealerIdFromToken = (token: any) => {
  const decodedJwt = decodeToken(token);
  // Get the profile object from token:
  const profileObj = JSON.parse(decodedJwt.profile);
  const dealerId = profileObj.dealerId;
  return dealerId;
};

/** Compare two filter item arrays within a data grid pro.*/
export const areFiltersEqual = (
  a: GridFilterItem[],
  b: GridFilterItem[]
): boolean => {
  if (a.length !== b.length) return false;
  return a.every((item, idx) => {
    const other = b[idx];
    return (
      item.columnField === other.columnField &&
      item.operatorValue === other.operatorValue &&
      item.value === other.value
    );
  });
};

export const isNullOrEmptyField = (value: any) => value == null || value === "";
